import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/category',
  title: 'Categorias',
  endpoint: '/public/store_product_category',
}
